import { useState } from 'react';
import { MessageCircle } from 'lucide-react';

// Support chat entry — a small square tab half-pushed off the right edge of
// the screen (casting's pattern), instead of the old full-width footer bar.
// Slides fully into view on hover/focus; click opens Chatlio (mailto fallback).
export const ChatFooter = () => {
  const [peeked, setPeeked] = useState(false);

  const openChat = () => {
    if (window._chatlio && typeof window._chatlio.show === 'function') {
      try {
        window._chatlio.show({ expanded: true });
      } catch (e) {
        console.error('Chatlio show failed:', e);
        window.open('mailto:hello@heyjoe.io', '_blank');
      }
    } else {
      window.open('mailto:hello@heyjoe.io', '_blank');
    }
  };

  return (
    <button
      type="button"
      onClick={openChat}
      onMouseEnter={() => setPeeked(true)}
      onMouseLeave={() => setPeeked(false)}
      onFocus={() => setPeeked(true)}
      onBlur={() => setPeeked(false)}
      aria-label="Chat with us"
      title="How can we help?"
      className="fixed inline-flex items-center justify-center"
      style={{
        right: 0,
        bottom: 110,
        zIndex: 40,
        width: 44,
        height: 44,
        borderRadius: '10px 0 0 10px',
        background: 'var(--hj-surface-1)',
        border: '1px solid var(--hj-hairline)',
        borderRight: 'none',
        color: 'var(--hj-ink-2)',
        cursor: 'pointer',
        transform: peeked ? 'translateX(0)' : 'translateX(50%)',
        transition: 'transform 0.18s ease',
        boxShadow: '0 2px 10px oklch(0 0 0 / 0.25)',
      }}
    >
      <MessageCircle className="h-4.5 w-4.5" style={{ width: 18, height: 18 }} />
      <span
        className="absolute rounded-full"
        style={{ top: 7, left: 7, width: 7, height: 7, background: 'var(--hj-green)' }}
      />
    </button>
  );
};
